import { useParams } from "react-router-dom";
import { useTranslation } from "react-i18next";

import { canonicalizeAlias } from "@/lib/meetVanity";
import MeetConference from "./MeetConference";

/**
 * Vanity-alias JOIN surface — served at the SPA ROOT for an alias-shaped
 * segment (`staging.orionmessenger.io/<alias>`) by `RootRouteGuard`, WITHOUT
 * navigating away, so `/<alias>` stays in the address bar (the whole point of a
 * vanity link).
 *
 * Reuses `MeetConference` verbatim, keyed on the alias instead of a meetingId:
 * the token endpoint accepts `{ alias }` directly (owner → moderator, others →
 * member; unknown/unclaimed alias → generic 404). No owner guest-link action in
 * V1 (guest-via-alias is a follow-up).
 *
 * The root route declares the param as `:chatId` (it is the same react-router
 * pattern a chat uses); for an alias-shaped value it IS the alias. It is
 * canonicalized (lowercased) for minting — the BE stores aliases lowercase —
 * while the address bar keeps whatever case the visitor typed.
 */
export default function VanityMeetJoin() {
  const { t } = useTranslation();
  const { chatId } = useParams<{ chatId?: string }>();
  const alias = chatId ? canonicalizeAlias(chatId) : "";
  // Canonical shareable link for the copy button; the address bar is untouched.
  const shareLink = `${window.location.origin}/${alias}`;

  return (
    <MeetConference
      mintRequest={{ alias }}
      identity={alias}
      shareLink={shareLink}
      notFoundTitle={t("standaloneMeet.vanityNotFoundTitle")}
      notFoundDescription={t("standaloneMeet.vanityNotFoundDescription")}
    />
  );
}
